import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';

const Projects = () => {
  const projects = [
    {
      title: 'Enterprise E-Commerce Platform',
      description:
        'Architected and built a scalable microservices-based e-commerce platform handling 100K+ daily transactions. Implemented payment gateway integration, inventory management, and real-time order tracking.',
      tech: ['Spring Boot', 'Microservices', 'MySQL', 'Redis', 'Kafka', 'AWS'],
      highlights: ['99.9% Uptime', 'Sub-200ms Response', '10x Performance Gain'],
    },
    {
      title: 'Real-Time Analytics Dashboard',
      description:
        'Developed a high-performance analytics engine processing millions of events per day. Built RESTful APIs, implemented data aggregation pipelines, and created visualization interfaces.',
      tech: ['Java', 'Spring Boot', 'MongoDB', 'React', 'Docker'],
      highlights: ['Real-time Processing', 'Scalable Architecture', 'Custom Dashboards'],
    },
    {
      title: 'Financial Services API Platform',
      description:
        'Designed and implemented a secure API platform for financial transactions. Ensured PCI compliance, implemented fraud detection, and built audit logging systems.',
      tech: ['Java', 'Spring Security', 'PostgreSQL', 'OAuth2', 'Kubernetes'],
      highlights: ['PCI Compliant', 'Zero Security Breaches', 'High Availability'],
    },
    {
      title: 'Cloud Migration & Optimization',
      description:
        'Led migration of legacy monolithic application to cloud-native microservices architecture. Reduced infrastructure costs by 40% while improving performance and reliability.',
      tech: ['Spring Cloud', 'Docker', 'Kubernetes', 'AWS', 'CI/CD'],
      highlights: ['40% Cost Reduction', 'Zero Downtime', 'Modern Architecture'],
    },
    {
      title: 'Healthcare Management System',
      description:
        'Built a HIPAA-compliant healthcare management system with patient records, appointment scheduling, and telemedicine capabilities. Prioritized security and data privacy.',
      tech: ['Spring Boot', 'MySQL', 'JWT', 'REST APIs', 'Encryption'],
      highlights: ['HIPAA Compliant', 'Secure Data Storage', 'User-Friendly'],
    },
    {
      title: 'AI-Powered Recommendation Engine',
      description:
        'Developed backend infrastructure for an ML-powered recommendation system. Integrated machine learning models, optimized data pipelines, and built scalable APIs.',
      tech: ['Java', 'Python', 'TensorFlow', 'Spring Boot', 'Redis'],
      highlights: ['ML Integration', 'Real-time Recommendations', 'High Accuracy'],
    },
  ];

  return (
    <section id="projects" className="py-5 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h2 className="section-title text-center">Selected Work</h2>
            <p className="section-subtitle text-center">
              Representative projects demonstrating technical expertise and problem-solving capabilities
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          {projects.map((project, idx) => (
            <Col lg={6} key={idx} className="mb-4">
              <Card className="h-100">
                <Card.Body>
                  <Card.Title className="fw-bold mb-3">{project.title}</Card.Title>
                  <Card.Text className="text-muted mb-3">{project.description}</Card.Text>
                  <div className="mb-3">
                    {project.tech.map((tech, techIdx) => (
                      <Badge key={techIdx} bg="light" text="dark" className="me-2 mb-2">
                        {tech}
                      </Badge>
                    ))}
                  </div>
                  <div className="border-top pt-3">
                    <small className="fw-semibold text-primary">Key Achievements:</small>
                    <ul className="mt-2 mb-0" style={{ fontSize: '0.9rem' }}>
                      {project.highlights.map((highlight, hIdx) => (
                        <li key={hIdx} className="text-muted">{highlight}</li>
                      ))}
                    </ul>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Projects;